import { RSAA } from 'redux-api-middleware';
import moment from 'moment';

export const INVOICES_IS_FETCHING = 'INVOICES_IS_FETCHING';
export const INVOICES_GET_LIST_SUCCESS = 'INVOICES_GET_LIST_SUCCESS';
export const INVOICES_GET_SUCCESS = 'INVOICES_GET_SUCCESS';
export const INVOICES_GET_ERROR = 'INVOICES_GET_ERROR';
export const INVOICES_SET_CURRENT_PAGE = 'INVOICES_SET_CURRENT_PAGE';
export const INVOICES_CLAIMS_SEND_ISSUE_SUCCESS = 'INVOICES_CLAIMS_SEND_ISSUE_SUCCESS';
export const INVOICES_PAYMENT_CARD_FIRST = 'INVOICES_PAYMENT_CARD_FIRST';
export const INVOICES_PAYMENT_CARD_SECOND = 'INVOICES_PAYMENT_CARD_SECOND';
export const INVOICES_DOWNLOAD_START = 'INVOICES_DOWNLOAD_START';
export const INVOICES_DOWNLOAD_END = 'INVOICES_DOWNLOAD_END';
export const INVOICES_PAYMENT_CARD_BACK_FIRST = 'INVOICES_PAYMENT_CARD_BACK_FIRST';
export const INVOICES_PAYMENT_CARD_BACK_SECOND = 'INVOICES_PAYMENT_CARD_BACK_SECOND';
export const INVOICES_PAYMENTS_RESET = 'INVOICES_PAYMENTS_RESET';
export const INVOICES_PAYMENT_CARD_PREVIEW = 'INVOICES_PAYMENT_CARD_PREVIEW';
export const INVOICES_PAYMENT_BANK_FIRST = 'INVOICES_PAYMENT_BANK_FIRST';
export const INVOICES_PAYMENT_BANK_SECOND = 'INVOICES_PAYMENT_BANK_SECOND';
export const INVOICES_PAYMENT_BANK_PREVIEW = 'INVOICES_PAYMENT_BANK_PREVIEW';
export const INVOICES_SET_SELECTED = 'INVOICES_SET_SELECTED';

const setCurrentMonthRange = () => {
  let today = moment();
  //if (today.date() >= 15) today = today.add(1, 'M');
  let firstDay = today.startOf('M').format();
  let lastDay = today.add(1, 'M').endOf('M').format();

  return {
    firstDay,
    lastDay
  };
};

// Initial State
export const initialState = {
  defaultSearchParams: {
    perPage: 25,
    page: 1,
    //fromDate: setCurrentMonthRange().firstDay,
    toDate: setCurrentMonthRange().lastDay
  },
  sorting: {
    prop: '',
    direction: ''
  },
  pagination: {
    page: 1,
    total: 0
  },
  isFetching: false,
  items: [],
  selectedItem: null,
  error: null,
  contactFormSent: false,
  nextStep: false,
  inDownload: '',
  debitCard: {
    number: '',
    expiry: '',
    code: '',
    owner: '',
    address: {
      street: '',
      city: '',
      state: '',
      zipCode: '',
      apt: ''
    }
  },
  debitCardReview: false,
  isCardFirstStep: false,
  isCardSecondStep: false,
  isPreview: false,
  isBankFirstStep: false,
  isBankSecondStep: false,
  bank: {
    selectedBank: '',
    accountName: '',
    routingNumber: '',
    accountNumber: '',
    accountNumberVerify: ''
  },
  selected: null,
  filters: [
    {
      key: 'subgroupKey',
      label: 'Subgroup ID',
      noSelectionText: 'View All Subgroups',
      isMultiSelect: true,
      options: [],
      selectedValue: null
    },
    {
      key: 'monthSelectKey',
      label: 'Date',
      noSelectionText: 'Choose Month',
      isMultiSelect: false,
      options: [],
      selectedValue: null
    }
  ]
};

// Actions
export const selectedInvoice = invoice => {
  return dispatch => {
    dispatch({ type: INVOICES_SET_SELECTED, meta: { ...invoice } });
  };
};

export const getInvoiceList = queryString => {
  var filteredSubgroupKey = '';
  if (queryString.subgroupKey) {
    filteredSubgroupKey =
      typeof queryString.subgroupKey !== 'string'
        ? queryString.subgroupKey.filter(key => key !== 'selectAll')
        : queryString.subgroupKey;
  }

  return {
    [RSAA]: {
      controlKey: 'CTRL_INVOICE',
      controlAction: 'collection',
      queryString: {
        page: queryString.page ? queryString.page : 1,
        perPage: queryString.perPage ? queryString.perPage : 25,
        fromDate: queryString.fromDate ? queryString.fromDate : '',
        toDate: queryString.toDate ? queryString.toDate : '',
        orderBy: queryString.orderBy ? queryString.orderBy : '',
        subgroupKey: filteredSubgroupKey ? filteredSubgroupKey : ''
      },
      types: [
        INVOICES_IS_FETCHING,
        {
          type: INVOICES_GET_LIST_SUCCESS,
          meta: { ...queryString }
        },
        INVOICES_GET_ERROR
      ]
    }
  };
};

export const getInvoiceDetails = id => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_INVOICE',
      controlAction: 'self',
      param: id,
      types: [INVOICES_IS_FETCHING, INVOICES_GET_SUCCESS, INVOICES_GET_ERROR]
    }
  };
};

export const sendInvoiceIssue = invoice => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_INVOICE_INQUIRY',
      controlAction: 'bci:submit',
      body: invoice,
      types: [INVOICES_IS_FETCHING, INVOICES_CLAIMS_SEND_ISSUE_SUCCESS, INVOICES_GET_ERROR]
    }
  };
};

export const startDownload = () => {
  return dispatch => {
    dispatch({ type: INVOICES_DOWNLOAD_START });
  };
};

export const stopDownload = () => {
  return dispatch => {
    dispatch({ type: INVOICES_DOWNLOAD_END });
  };
};

export const setBankFirstStep = data => {
  return {
    type: INVOICES_PAYMENT_BANK_FIRST,
    meta: { ...data }
  };
};

export const setBankSecondStep = data => {
  return {
    type: INVOICES_PAYMENT_BANK_SECOND,
    meta: { ...data }
  };
};

export const setDebitCardFirstStep = data => {
  return {
    type: INVOICES_PAYMENT_CARD_FIRST,
    meta: { ...data }
  };
};

export const setDebitCardSecondStep = data => {
  return {
    type: INVOICES_PAYMENT_CARD_SECOND,
    meta: { ...data }
  };
};

export const getDebitCardPreview = data => {
  return {
    type: INVOICES_PAYMENT_CARD_PREVIEW,
    meta: { ...data }
  };
};

export const goBackFirstStep = () => {
  return {
    type: INVOICES_PAYMENT_CARD_BACK_FIRST
  };
};

export const goBackSecondStep = () => {
  return {
    type: INVOICES_PAYMENT_CARD_BACK_SECOND
  };
};

export const goPayments = () => {
  return {
    type: INVOICES_PAYMENTS_RESET
  };
};

export const resetStatePayments = () => {
  return {
    type: INVOICES_PAYMENTS_RESET
  };
};

export const getBankPreview = data => {
  return {
    type: INVOICES_PAYMENT_BANK_PREVIEW,
    meta: { ...data }
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case INVOICES_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case INVOICES_SET_SELECTED:
      return { ...state, isFetching: false, selected: action.meta };

    case INVOICES_DOWNLOAD_START:
      return { ...state, isFetching: true, error: null, inDownload: 'DOWNLOADING INVOICE' };

    case INVOICES_DOWNLOAD_END:
      return { ...state, isFetching: false, error: null, inDownload: '' };

    case INVOICES_GET_LIST_SUCCESS:
      let prop, direction;
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        prop = splitted[0];
        if (prop === state.sorting.prop) {
          direction = splitted[1];
        } else {
          direction = 'asc';
        }
      }
      const out = {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items,
        subgroupSelectedFilter: action.meta && action.meta.subgroupKey ? action.meta.subgroupKey : null,
        filters: [...state.filters].map(e => {
          let selectedValue = action.meta[e.key] ? action.meta[e.key] : null;
          return {
            ...e,
            selectedValue
          };
        }),
        pagination: {
          ...state.pagination,
          page: +action.meta.page,
          total: action.payload.pageCount
        },
        sorting: {
          ...state.sorting,
          prop: prop ? prop : state.sorting.prop,
          direction: direction === 'asc' ? ':desc' : ':asc'
        },
        searchParams: {
          fromDate: action.meta.fromDate,
          toDate: action.meta.toDate,
          subgroupKey: action.meta.subgroupKey
        },
        contactFormSent: false
      };
      return out;

    case INVOICES_GET_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case INVOICES_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        selectedItem: action && action.payload && action.payload.invoice ? action.payload.invoice : null
      };

    case INVOICES_SET_CURRENT_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          current: Number(action.page)
        }
      };

    case INVOICES_CLAIMS_SEND_ISSUE_SUCCESS:
      return {
        ...state,
        contactFormSent: true
      };

    case INVOICES_PAYMENT_BANK_FIRST:
      return {
        ...state,
        isBankFirstStep: true,
        isBankSecondStep: false
      };

    case INVOICES_PAYMENT_BANK_SECOND:
      return {
        ...state,
        isBankFirstStep: false,
        isBankSecondStep: true,
        bank: {
          ...state.bank,
          selectedBank: action.meta.bank,
          accountName: action.meta.nameAccount,
          routingNumber: action.meta.routingNumber,
          accountNumber: action.meta.accountNumber,
          accountNumberVerify: action.meta.confirmAccountNumber
        }
      };

    case INVOICES_PAYMENT_BANK_PREVIEW:
      return {
        ...state,
        isBankFirstStep: false,
        isBankSecondStep: false,
        isPreview: true,
        bank: {
          ...state.bank,
          accountName: action.meta.accountName,
          routingNumber: action.meta.routing,
          accountNumber: action.meta.accountNumber,
          accountNumberVerify: action.meta.accountNumberVerify
        }
      };

    case INVOICES_PAYMENT_CARD_FIRST:
      return {
        ...state,
        isCardFirstStep: true,
        isCardSecondStep: false,
        isPreview: false,
        debitCard: {
          ...state.debitCard,
          number: action.meta.cardNumber,
          expiry: action.meta.cardExpiry,
          code: action.meta.cardCode
        }
      };

    case INVOICES_PAYMENT_CARD_SECOND:
      return {
        ...state,
        isCardFirstStep: false,
        isCardSecondStep: true,
        isPreview: false
      };

    case INVOICES_PAYMENT_CARD_PREVIEW:
      return {
        ...state,
        isCardFirstStep: false,
        isCardSecondStep: false,
        isPreview: true,
        debitCard: {
          ...state.debitCard,
          owner: action.meta.cardName,
          number: action.meta.cardNumber,
          expiry: action.meta.cardExpiry,
          code: action.meta.cardCode,
          address: {
            ...state.debitCard.address,
            street: action.meta.cardAddress,
            city: action.meta.cardCity,
            state: action.meta.cardState,
            zipCode: action.meta.cardZipCode,
            apt: action.meta.cardApt
          }
        }
      };

    case INVOICES_PAYMENT_CARD_BACK_FIRST:
      return {
        ...state,
        isCardFirstStep: true,
        isCardSecondStep: false,
        isPreview: false,
        isBankFirstStep: true,
        isBankSecondStep: false
      };

    case INVOICES_PAYMENT_CARD_BACK_SECOND:
      return {
        ...state,
        isCardFirstStep: false,
        isCardSecondStep: true,
        isPreview: false,
        isBankSecondStep: true
      };

    case INVOICES_PAYMENTS_RESET:
      return {
        ...state,
        isCardFirstStep: false,
        isCardSecondStep: false,
        isPreview: false,
        isBankFirstStep: false,
        isBankSecondStep: false,
        debitCard: {
          number: '',
          expiry: '',
          code: '',
          owner: '',
          address: {
            street: '',
            city: '',
            state: '',
            zipCode: '',
            apt: ''
          }
        },
        bank: {
          selectedBank: '',
          accountName: '',
          routingNumber: '',
          accountNumber: '',
          accountNumberVerify: ''
        }
      };

    case '@@router/LOCATION_CHANGE':
      return { ...state };

    default:
      return { ...state };
  }
};
